import { TextCodes } from '@api/types/translation/TextCodes';
import { ProductDetailsContext } from '@components';
import { Box, styled } from '@mui/material';
import { colors } from '@themes/colors';
import { t } from '@translations';
import classnames from 'classnames';
import { useContext } from 'react';

const StockInfo = styled(Box)`
  display: flex;
  gap: 16px;
  align-items: center;
`;

const InfoIndicator = styled(Box)`
  height: 12px;
  width: 12px;
  background: ${colors.primary.mainGreen};
  border-radius: 6px;

  &.not-in-stock {
    background: #df5f36;
  }
`;
const STOCK_QUANTITY_THRESHOLD = 50;
export const ProductStockInfo = () => {
  const { product = {} } = useContext(ProductDetailsContext);
  const { stockQuantity = 0 } = product;
  const inStock = stockQuantity > 0;
  const indicatorClassName = classnames({ 'not-in-stock': !inStock });
  return (
    <StockInfo>
      <InfoIndicator className={indicatorClassName} />
      {inStock &&
        stockQuantity < STOCK_QUANTITY_THRESHOLD &&
        t(TextCodes.Product.Details.BelowThresholdStock, {
          stockQuantity: stockQuantity.toString(),
        })}
      {inStock &&
        stockQuantity >= STOCK_QUANTITY_THRESHOLD &&
        t(TextCodes.Product.Details.AboveThresholdStock, {
          thresholdStock: STOCK_QUANTITY_THRESHOLD.toString(),
        })}
      {!inStock && t(TextCodes.Product.Details.ToBeOrdered)}
    </StockInfo>
  );
};
